import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "src/environments/environment";
import { AuthService } from "src/app/shared/services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.hasToken() && (request.url.includes(environment.apiUrl) || request.url.includes(environment.apiUrlV2) || request.url.includes(environment.apiUrlV4) || request.url.includes(environment.apiUrlV3) || request.url.includes(environment.widgetUrl))) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.token}`,
        },
      });
    }
    return next.handle(request);
  }
}
